
import { onMounted, nextTick, watch, ref, computed, reactive } from 'vue'
import store from '@/store/index'
import { DISPLAY_RANGE_MAP } from '@/consts/task_dot'

export default {
  name: 'DotQueTile',
  props: {
    questionData: {
      type: Object,
      default: () => ({})
    },
    questionIndex: {
      type: Number,
      default: 0
    },
    displayRange: {
      type: Number,
      default: 0
    },
    curTime: {
      type: Number,
      default: 0
    }
  },
  emits: ['handleAfterRender', 'handleChooseOption'],
  setup(props, { emit }) {
    // alert(`${document.documentElement.clientWidth}~${document.documentElement.clientHeight}`)
    let realWidth = 0
    let realHeight = 0
    // const maxWidth = ref((document.documentElement.clientWidth / 2 - 70) || 376)
    const maxWidth = ref(376)
    // alert(maxWidth.value)
    // const maxHeight = ref(224)
    const tempMaxHeight = document.documentElement.clientHeight * 0.43
    const maxHeight = ref(tempMaxHeight > 224 ? tempMaxHeight : 224)
    // console.log(maxHeight.value, 'maxHeight')
    const queSectionStyle = reactive({})
    const refQueTileWrap = ref(null)
    const refQueDetail = ref(null)
    const refQueTileWrapFake = ref(null)
    const queTypeDes = ref(props.questionData?.logicQuesTypeName || '')
    const total = ref(0)
    const isDecidable = ref(true)
    const currentTime = computed(() => {
      return props.curTime
    })
    const answerOptionList = computed(() => {
      return props.questionData?.answerOptionList || []
    })
    const rightAnswer = computed(() => {
      return props.questionData?.normalAnswer?.[0] || []
    })
    const curClickVal = ref('')
    const displayRangeMap = ref(DISPLAY_RANGE_MAP)
    const handleAfterRender = (data) => {
      emit('handleAfterRender', data)
    }
    const handleOptionsClick = (val) => {
      curClickVal.value = val
      emit('handleChooseOption', {
        data: [val],
        queId: props.questionData.queId,
        rootId: props.questionData.queId,
        type: props.questionData.logicQuesTypeId
      })
    }
    watch(currentTime, (val) => {
      renderQuestion()
    })
    onMounted(() => {
      renderQuestion()
    })
    const renderQue = (domEle, data) => {
      domEle.innerHTML = (window as any).TalqsTemplate.renderPartialComponent('questionContent', data, {
        hideDifficulty: true,
        hideSource: true,
        hideCamera: true,
      });
      (window as any).MathJax.Hub.Queue(['Typeset', (window as any).MathJax.Hub, document.querySelector('#questionAllData')]);
      window['TalqsInteraction'].initTqiQs();
    }
    // 渲染题目信息
    const renderQuestion = () => {
      curClickVal.value = ''
      let data = props.questionData;
      // console.log(data, '题目信息')
      // let questionIndex = props.questionIndex;
      window['TalqsInteraction'].setUserConfig(store.getters.talqsInteractionConfig);
      nextTick(() => {
        let questionTitleDom: any = refQueTileWrap.value;
        let questionTitleDomFake: any = refQueTileWrapFake.value;
        try {
          if (displayRangeMap.value.QUE_ALL !== props.displayRange) {
            emit('handleAfterRender', {})
            return
          }
          renderQue(questionTitleDomFake, data)
          nextTick(() => {
            // console.log(refQueDetail.value, refQueDetail.value.offsetWidth)
            realWidth = questionTitleDomFake.offsetWidth + 4 > maxWidth.value ? maxWidth.value : questionTitleDomFake.offsetWidth + 4
            realWidth = realWidth > 208 ? realWidth : 208
            Object.assign(queSectionStyle, {width:`${realWidth}Px`})
            renderQue(questionTitleDom, data)
            nextTick(() => {
              let timer = setTimeout(() => {
                realHeight = refQueDetail.value.offsetHeight + 40 > maxHeight.value ? maxHeight.value : refQueDetail.value.offsetHeight + 40
                // console.log(refQueDetail.value.offsetHeight, 'refQueDetail.value.offsetHeight')
                handleAfterRender({width: realWidth, height: realHeight})
                clearTimeout(timer)
              }, 200)
            })
          })
        } catch (e) {
          console.log('error', e);
        }
      });
    }
    return {
      queTypeDes,
      total,
      isDecidable,
      refQueTileWrap,
      refQueTileWrapFake,
      refQueDetail,
      answerOptionList,
      curClickVal,
      rightAnswer,
      handleOptionsClick,
      displayRangeMap,
      queSectionStyle
    }
  }
}
